"use client";
import PureworkerPro from '../agent/PureworkerPro';
import ArtisanNominations from '../agent/ArtisanNominations';
import AdLinks from '../agent/adLinks';
import OperationsCosts from "../agent/operationsCosts";
import BulkSms from "../bulkSms";
import AppChats from '../AppChats';
import React from "react";
import AdminNavigation from "../../components/AdminNavigation";
import DashboardContent from "../../components/sidebarContents/dasboardContent";
import RegistrationsPage from "../registrations";
import ServicesContent from "../../components/sidebarContents/servicesContent";
import NotificationContent from "../../components/sidebarContents/notificationContent";
import SettingsContent from "../../components/sidebarContents/settingsContent";
import ChatContent from "../../components/sidebarContents/chatContent";
import VerificationContent from "../../components/sidebarContents/verificationContent";

import ProfilePage from "../profilePage";
// import WalletCustomer from "../wallet-customer";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { RootState } from "../../utils/redux/store";
import { useAppSelector } from "../../utils/redux/hooks";
import Customers1 from "../customer";
import Customers2 from "../customer/index2";
import Customers3 from "../customer/index3";
import Customers4 from "../customer/index4";
import Customers5 from "../customer/index5";
import Provider5 from "../provider/index5";
import Provider4 from "../provider/index4";
import Provider3 from "../provider/index3";
import Provider2 from "../provider/index2";
import Provider1 from "../provider";
import ProviderProfile from "../provider/profile";
import VerifiedProviders from "../provider/verified";
import AllNotifications from "../../components/helpers/notificationTab/allNotifications";
import Agents from "../../components/sidebarContents/agents";
import EditAgent from "../../components/helpers/agentTabs/editAgent";
import LoginForm from "../login";
import ProtectedRoute from "../config/Protected";
import Verificationprofile from "../verification/profile";
import VerifyNIN from "../verification/VerifyNIN";
import BlogContent from "../../components/sidebarContents/BlogContent";
import Referrals from "../../components/sidebarContents/Referrals";
import LessThanTwoStars from "../../components/sidebarContents/LessThanTwoStars";
import CreateBlog from "../../components/sidebarContents/CreateBlog";
import BlogPage from "../../components/sidebarContents/BlogPage";
import IDCheck from "../idcheck";
import Index2 from "../referrals/index2";
import CustomizeAgent from "../referrals/customize";
import PromoCode from "../promoCode";
import NewPromoCode from "../promoCode/NewPromoCode";
import EditPromoCode from "../promoCode/EditPromoCode";
import AuditLog from "../agent/auditLog";
import Conversations from "../agent/conversations";
import DispatchJobs from "../agent/dispatchJobs";
import Requests from "../agent/requests";
import DeadLetters from "../agent/deadLetters";
import FlagReview from "../agent/flagReview";
import AgentMetrics from "../agent/agentMetrics";
import Blocklist from "../agent/blocklist";
import Intros from "../agent/intros";
import Ratings from "../agent/ratings";
import ProviderPerformance from "../agent/providerPerformance";
import ProviderRanking from "../provider/ranking";
import ProviderRecommendations from "../agent/providerRecommendations";
import JobDemand from "../agent/jobDemand";
import Waitlist from "../agent/waitlist";
import Suspensions from "../agent/suspensions";
import DevData from "../agent/devData";
const Telemarketer = React.lazy(() => import('../field/Telemarketer'));
const FieldWorkspace = React.lazy(() => import('../field/FieldWorkspace'));
const Outreach = React.lazy(() => import('../emails/Outreach'));
const EmailComposer = React.lazy(() => import('../emails/EmailPages').then(module => ({default: module.EmailComposer})));
const EmailTemplates = React.lazy(() => import('../emails/EmailPages').then(module => ({default: module.EmailTemplates})));
const PausedEmails = React.lazy(() => import('../emails/PausedEmails'));
const ExcludedEmails = React.lazy(() => import('../emails/ExcludedEmails'));


interface SidebarProps {
  profile: boolean;
  setProfile: (profile: boolean) => void;
}
const SidebarComp: React.FC<SidebarProps> = ({ profile, setProfile }) => {
  const userData: any = useAppSelector((store: RootState) => store.user.userData);
  const signedIn = useAppSelector((store: RootState) => store.user.isLoggedIn?.authenticated) || localStorage.getItem("pw_admin_session") === "1";
  const isLoading = useAppSelector((store: RootState) => store.user.isLoading);
  return (
    <>
      <div className="admin-shell">
        <div className="admin-layout">
          {signedIn && <aside className="admin-sidebar"><AdminNavigation /></aside>}
          <div className="admin-content" id="admin-content" tabIndex={-1}>
            <Routes>
              <Route path="/outreach" element={<ProtectedRoute><React.Suspense fallback={<p>Loading outreach...</p>}><Outreach /></React.Suspense></ProtectedRoute>} />
              <Route path="/field-work/telemarketer" element={<ProtectedRoute><React.Suspense fallback={<p>Loading telemarketer workspace...</p>}><Telemarketer /></React.Suspense></ProtectedRoute>} />
              <Route path="/telemarketing" element={<ProtectedRoute><React.Suspense fallback={<p>Loading Telemarketing...</p>}><Telemarketer /></React.Suspense></ProtectedRoute>} />
              <Route path="/field-work" element={<ProtectedRoute><React.Suspense fallback={<p>Loading field workspace?</p>}><FieldWorkspace /></React.Suspense></ProtectedRoute>} />
              <Route path="/verified-providers" element={<ProtectedRoute><VerifiedProviders /></ProtectedRoute>} />
              <Route path="/unverified-providers" element={<ProtectedRoute><VerifiedProviders group="unverified" /></ProtectedRoute>} />
              <Route path="/registrations" element={<ProtectedRoute><RegistrationsPage /></ProtectedRoute>} />
              <Route path="/emails" element={<ProtectedRoute><React.Suspense fallback={<p>Loading emails...</p>}><EmailComposer /></React.Suspense></ProtectedRoute>} />
              <Route path="/email-templates" element={<ProtectedRoute><React.Suspense fallback={<p>Loading templates...</p>}><EmailTemplates /></React.Suspense></ProtectedRoute>} />
              <Route path="/emails/excluded" element={<ProtectedRoute><React.Suspense fallback={<p>Loading excluded emails...</p>}><ExcludedEmails /></React.Suspense></ProtectedRoute>} />
              <Route path="/emails/paused" element={<ProtectedRoute><React.Suspense fallback={<p>Loading paused emails...</p>}><PausedEmails /></React.Suspense></ProtectedRoute>} />
                {/* "/" used to render the LOGIN FORM behind the auth guard, so
                    a signed-in admin landing on the bare domain got a login box
                    sitting inside their own dashboard chrome. The guard already
                    sends a signed-OUT visitor to /login, so the only thing left
                    for "/" to do is go to the dashboard. */}
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/dashboard" replace />
                    </ProtectedRoute>
                  }
                />
              <Route path="/login" element={<LoginForm />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers"
                element={
                  <ProtectedRoute>
                    <Customers1 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers/:id"
                element={
                  <ProtectedRoute>
                    <ProviderProfile customer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers/:id/orders"
                element={<ProtectedRoute><Customers2 /></ProtectedRoute>}
              />
              <Route
                path="/customers3"
                element={
                  <ProtectedRoute>
                    <Customers3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers/orderDetails"
                element={
                  <ProtectedRoute>
                    <Customers4 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customers5"
                element={
                  <ProtectedRoute>
                    <Customers5 />
                  </ProtectedRoute>
                }
              />
              {/* <Route path="/serviceProviders" element={<ProtectedRoute><ServiceProvidersContent />} /> */}
              <Route
                path="/serviceProviders"
                element={
                  <ProtectedRoute>
                    <Provider1 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/provider/:id"
                element={<ProtectedRoute><ProviderProfile /></ProtectedRoute>}
              />
              <Route
                path="/provider/:id/orders"
                element={
                  <ProtectedRoute>
                    <Provider2 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/provider3"
                element={
                  <ProtectedRoute>
                    <Provider3 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/provider/orderDetails"
                element={
                  <ProtectedRoute>
                    <Provider4 />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/provider5"
                element={
                  <ProtectedRoute>
                    <Provider5 />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/services"
                element={
                  <ProtectedRoute>
                    <ServicesContent />
                  </ProtectedRoute>
                }
              />
  <Route
    path="/promoCode"
    element={
      <ProtectedRoute>
        <PromoCode />
      </ProtectedRoute>
    }
  />
  <Route
    path="/promoCode/new"
    element={
      <ProtectedRoute>
        <NewPromoCode /> 
      </ProtectedRoute>
    }
  />
  <Route
    path="/promoCode/edit/:id"
    element={
      <ProtectedRoute>
        <EditPromoCode /> 
      </ProtectedRoute>
    }
  />
<Route
                path="/notification"
                element={
                  <ProtectedRoute>
                    <NotificationContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/notification/all"
                element={
                  <ProtectedRoute>
                    <AllNotifications />
                  </ProtectedRoute>
                }
              />
<Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <SettingsContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat"
                element={
                  <ProtectedRoute>
                    <ChatContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profilePage"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
<Route
                path="/verification"
                element={
                  <ProtectedRoute>
                    <VerificationContent />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/verification/:id"
                element={
                  <ProtectedRoute>
                    <Verificationprofile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/id-check/:id/verify-nin"
                element={
                  <ProtectedRoute>
                    <VerifyNIN />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/verification/:id/verify-nin"
                element={
                  <ProtectedRoute>
                    <VerifyNIN />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/blog"
                element={
                  <ProtectedRoute>
                    <BlogContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/blog/:id"
                element={
                  <ProtectedRoute>
                    <BlogPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create-blog"
                element={
                  <ProtectedRoute>
                    <CreateBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/referrals"
                element={
                  <ProtectedRoute>
                    <Referrals />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/referrals/customize/:id"
                element={
                  <ProtectedRoute>
                    <CustomizeAgent />
                  </ProtectedRoute>
                }
              />
<Route
                path="/lessthantwostars"
                element={
                  <ProtectedRoute>
                    <LessThanTwoStars />
                  </ProtectedRoute>
                }
              />

              <Route path="/agents" element={<ProtectedRoute>{!userData ? <p role="status">Checking admin permissions...</p> : userData.accountType?.toLowerCase() === "super_admin" ? <Agents /> : <Navigate to="/dashboard" replace />}</ProtectedRoute>} />
              {/* Agent admin (consolidated): proxied to the WhatsApp agent */}
              <Route
                path="/audit-log"
                element={
                  <ProtectedRoute>
                    <AuditLog />
                  </ProtectedRoute>
                }
              />
              <Route path="/app-chats" element={<ProtectedRoute><AppChats /></ProtectedRoute>} />
              <Route path="/conversations" element={<ProtectedRoute><Conversations /></ProtectedRoute>} />
              <Route path="/agent-teaching" element={<ProtectedRoute><Navigate to="/conversations" replace /></ProtectedRoute>} />
              <Route path="/requests" element={<ProtectedRoute><Requests /></ProtectedRoute>} />
              <Route path="/dispatch-jobs" element={<ProtectedRoute><DispatchJobs /></ProtectedRoute>} />
              <Route path="/dead-letters" element={<ProtectedRoute><DeadLetters /></ProtectedRoute>} />
              <Route path="/flag-review" element={<ProtectedRoute><FlagReview /></ProtectedRoute>} />
              <Route path="/pureworker-pro" element={<ProtectedRoute><PureworkerPro /></ProtectedRoute>} />
              <Route path="/artisan-nominations" element={<ProtectedRoute><ArtisanNominations /></ProtectedRoute>} />
              <Route path="/ad-campaigns" element={<ProtectedRoute><AdLinks /></ProtectedRoute>} />
              <Route path="/costs" element={<ProtectedRoute><OperationsCosts /></ProtectedRoute>} />
              <Route path="/bulk-sms" element={<ProtectedRoute><BulkSms /></ProtectedRoute>} />
              <Route path="/agent-metrics" element={<ProtectedRoute><AgentMetrics /></ProtectedRoute>} />
              <Route path="/blocklist" element={<ProtectedRoute><Blocklist /></ProtectedRoute>} />
              <Route path="/ratings-reviews" element={<ProtectedRoute><Ratings /></ProtectedRoute>} />
              <Route path="/provider-performance" element={<ProtectedRoute><ProviderPerformance /></ProtectedRoute>} />
              <Route path="/provider-ranking" element={<ProtectedRoute><ProviderRanking /></ProtectedRoute>} />
              <Route path="/job-demand" element={<ProtectedRoute><JobDemand /></ProtectedRoute>} />
              <Route path="/provider-recommendations" element={<ProtectedRoute><ProviderRecommendations /></ProtectedRoute>} />
              <Route path="/intros" element={<ProtectedRoute><Intros /></ProtectedRoute>} />
              <Route path="/waitlist" element={<ProtectedRoute><Waitlist /></ProtectedRoute>} />
              <Route path="/suspensions" element={<ProtectedRoute><Suspensions /></ProtectedRoute>} />
              <Route path="/dev-data" element={<ProtectedRoute><DevData /></ProtectedRoute>} />

              <Route
                path="*"
                element={
                  <ProtectedRoute>
                    <div className="p-6 space-y-4">
                      <p className="text-xl font-bold">Route not found </p>
                      <button className="bg-purple-600 rounded-md  hover:bg-purple-400 py-3 px-4 text-white font-bold">
                        <Link to="/dashboard">Return to dashboard</Link>
                      </button>
                    </div>
                  </ProtectedRoute>
                }
              />
<Route
                path="/id-check"
                element={
                  <ProtectedRoute>
                    <IDCheck />
                  </ProtectedRoute>
                }
              />
<Route
                path="/agents/edit/:id"
                element={
                  <ProtectedRoute>
                    {!userData ? <p role="status">Checking admin permissions...</p> : userData.accountType?.toLowerCase() === "super_admin" ? <EditAgent /> : <Navigate to="/dashboard" replace />}
                  </ProtectedRoute>
                }
              />

              <Route
                path="/referrals/:id"
                element={
                  <ProtectedRoute>
                    <Index2 />
                  </ProtectedRoute>
                }
              />
            </Routes>
            {isLoading && (
              // <div className="loader-container">
              //   <div className="spinner"></div>
              // </div>
              <div className="loader-container ">
                <div className="spinner"></div>
              </div>
            )}
          </div>
        </div>

      </div>
    </>
  );
};

export default SidebarComp;
